import { NgModule, Component, ViewChild, ViewChildren, OnInit, AfterViewInit, SecurityContext } from '@angular/core';
import { Router, Route } from "@angular/router";
import { CommonConstants, RouteURLConstants, ServiceURLConstants, ApiErrorCode, ConfirmationFlowConstants, UTagConstants } from '../../constants/upplm.constants';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { SessionResponse } from '../../api/models/SessionResponse';
import { SessionRequest } from '../../api/models/SessionRequest';
import { NotificationDetailsSession, AditionalEmail } from '../../api/models/notificationDetailsSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { UtagService } from '../../services/upplm.utag.service';
import { TranslateDataPipe } from '../../pipes/translation.pipe';

@Component({
    selector: 'notificationdetails',
    template: require('./notificationDetails.component.html'),
    styles: ['.container-section-email{padding-left: 0px !important;} #emailTile1{padding-left: 0px}  #emailTile3{padding-left: 0px} #emailTile5{padding-left: 0px} .section-secondary-email{background-color: #fff; border: 2px solid #757575;}']
})

export class NotificationDetailsComponent implements OnInit, AfterViewInit {
    sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = false;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    public maxEmails: number;
    public numIndex: number;
    public email: string = '';
    public primaryEmail: string = '';
    public aditionalEmails: AditionalEmail[] = [];
    public aditionalEmailsBkp: AditionalEmail[] = [];
    Errors: any[];
    notifyMe: boolean = true;
    notifyMeBkp: boolean = true;

    constructor(private router: Router,
        private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _pbService: ProgressBarService,
        private _utagService: UtagService,
        private _translateDataPipe: TranslateDataPipe) { }

    ngOnInit() {
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_NOTIFICATION_START, UTagConstants.UPPLM_NOTIFICATION_DETAILS_START_SCREEN);
        this.isInitialLoadding = true;
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                }

                if (this.sessionData.notificationDetails) {
                    this.aditionalEmailsBkp = this.sessionData.notificationDetails.aditionalEmails.map(item => item);
                    this.notifyMeBkp = this.sessionData.notificationDetails.notifyMe;
                    this.bindDataFromSession(this.sessionData.notificationDetails);
                }
                this.maxEmails = (this.sessionData.contactDetails.makePrimaryContact) ? 4 : 3;
                this.email = this.sessionData.contactDetails.email;
                this.primaryEmail = (this.sessionData.contactDetails.makePrimaryContact) ? " " : this.sessionData.contactDetails.primaryEmail;
                this.numIndex = (this.maxEmails == 4) ? 2 : 3;
            } else {
                this.SessionErrorModal.open();
            }
            this.isInitialLoadding = false;
        });
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    bindDataFromSession(data: NotificationDetailsSession) {
        if (!this.sessionData.contactDetails.makePrimaryContact && data.aditionalEmails.length == 4) {
            data.aditionalEmails.splice(3, 1);
            this.aditionalEmails = data.aditionalEmails;
        }
        else {
            this.aditionalEmails = data.aditionalEmails;
        }
        this.notifyMe = data.notifyMe;
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;

        if (update) {
            let data: NotificationDetailsSession = new NotificationDetailsSession();
            //TODO
            data.aditionalEmails = this.aditionalEmails;
            data.notifyMe = this.notifyMe;
            data.showStatusBar = false; // Add
            request.notificationDetails = data;
        }
        else {
            request.notificationDetails = this.sessionData.notificationDetails;
            this.pbDetails.showStatusBar = this._pbService.pb.showStatusBar;
        }
        request.lastTimeSessionReqired = new Date().toString();
        this._pbService.pb = this.pbDetails;
        return request;
    }

    createSessionRequestBack(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;

        if (update) {
            let data: NotificationDetailsSession = new NotificationDetailsSession();
            //TODO
            data.aditionalEmails = this.aditionalEmails;
            data.notifyMe = this.notifyMe;
            data.showStatusBar = true;// Add
            request.notificationDetails = data;
        }
        else {
            request.notificationDetails = this.sessionData.notificationDetails;
            this._pbService.pb.showStatusBar = this._pbService.pb.showStatusBar;
        }
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateDataPipe.transform('upplm.common.sessiontimedouttitle')
        });
        this.SessionErrorModal.setProperties({
            title: this._translateDataPipe.transform('upplm.common.serviceerror')
        });
    }

    addEmail() {
        if (this.aditionalEmails.length < this.maxEmails) {
            this.aditionalEmails.push(new AditionalEmail());
        }
    }

    removeEmail(index) {
        this.aditionalEmails.splice(index, 1);
    }

    nextPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            for (var i = 0; i < this.aditionalEmails.length; i++) {
            }
            this.displayErrors();
            if (this.Errors.length == 0) {
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
            }
        }
    }

    backPage() {
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PICKUP_DETAILS_ROUTE);
    }

    cancelGoReviewPage() {
        this.aditionalEmails = [];
        this.aditionalEmails = this.aditionalEmailsBkp;
        this.notifyMe = this.notifyMeBkp;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });        
    }

    displayErrors() {
        this.Errors = [];

        for (var i = 0; i < this.aditionalEmails.length; i++) {
            var mail = this.aditionalEmails[i];
            if (mail.email == '') {
                this.Errors = this.Errors.concat(this.addError('Email', this._translateDataPipe.transform('upplm.common.email') + (i + this.numIndex), 'required'));
            }
            else {
                if (!mail.validEmail) {
                    this.Errors = this.Errors.concat(this.addError('Email', this._translateDataPipe.transform('upplm.notificationdetails.enteravalidemail') + (i + this.numIndex), 'invalidFormat'));
                }
            }
        }
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.isLoadding = true;
            if (target == RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE) {
                this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true)).subscribe((response: SessionResponse) => {
                    if (response.commonResponse.isSuccess) {
                        this._sessionService.mapSessionResponse(response);
                        //Go to Review
                        this._pbService.pb = new ProgressBarDetails();
                        this._pbService.pb.locationPB = "true";
                        this._pbService.pb.contactPB = "true";
                        this._pbService.pb.placardPB = "true";
                        this._pbService.pb.pickupPB = "true";
                        this._pbService.pb.notificationPB = "true";
                        this._pbService.pb.showStatusBar = false;
                        this.router.navigateByUrl(target);
                    }
                });
            }
            else {
                this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequestBack(true)).subscribe((response: SessionResponse) => {
                    if (response.commonResponse.isSuccess) {
                        this._sessionService.mapSessionResponse(response);
                        //Go to Pickup Point
                        this._pbService.pb = new ProgressBarDetails();
                        this._pbService.pb.locationPB = "true";
                        this._pbService.pb.contactPB = "true";
                        this._pbService.pb.placardPB = "true";
                        this._pbService.pb.pickupPB = "false";
                        this.router.navigateByUrl(target);
                    }
                });
            }
        }
    }

    onChange(newValue, index) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (validEmailRegEx.test(newValue)) {
            this.aditionalEmails[index].validEmail = true;
        } else {
            this.aditionalEmails[index].validEmail = false;
        }
    }

    public focusoutHandler(newValue: any, index: any) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!validEmailRegEx.test(newValue.target.value)) {
            this.aditionalEmails[index].validEmail = false;
            this.aditionalEmails[index].emailFlag = true;
        }
    }

}